import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import LeftNav from '@/components/nav/leftNav'
import TopNav from '@/components/nav/topNav'
import home from '@/components/container/home'
import systeam from '@/components/container/systeam'

import ActiveTabs from '@/components/ActiveTabs/ActiveTabs'

// 服务管理
export const ServiceManage = [
  {
    path: 'accessManage',
    name: '调用方管理',
    components: {
      default: () => import('@/pages/ServiceManage/AccessManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'serveManage',
    name: '服务管理',
    components: {
      default: () => import('@/pages/ServiceManage/ServeManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }
]

// 配置管理
export const SettingManage = [
  {
    path: 'messageTemplateConfiguration',
    name: '消息模板配置',
    components: {
      default: () => import('@/pages/SettingManage/MessageTemplateConfiguration'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'dataIndicatorManage',
    name: '指标管理',
    components: {
      default: () => import('@/pages/SettingManage/dataIndicatorManage/dataIndicatorManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'standardCodeManage',
    name: '标准码配置',
    components: {
      default: () => import('@/pages/SettingManage/StandardCodeManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'paramsManage',
    name: '参数配置',
    components: {
      default: () => import('@/pages/SettingManage/ParamsManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'encodeRule',
    name: '编码规则配置',
    components: {
      default: () => import('@/pages/SettingManage/EncodeRule'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  // systemSource
  {
    path: 'systemSource',
    name: '系统资源',
    components: {
      default: () => import('@/pages/SettingManage/systemSource'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/encodeRecord',
    name: '编码使用记录',
    components: {
      default: () => import('@/pages/SettingManage/EncodeRecord'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/generalEntity',
    name: '通用实体管理',
    components: {
      default: () => import('@/pages/SettingManage/GeneralEntity'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/generalRowDetail',
    name: '实体记录查询',
    components: {
      default: () => import('@/pages/SettingManage/GeneralRowDetail'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/attributeDefinition',
    name: '实体属性列表',
    components: {
      default: () => import('@/pages/SettingManage/AttributeDefinition'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }

]

// 资源管理
export const ResourceManage = [
  {
    path: '/permissionManage',
    name: '权限项管理',
    components: {
      default: () => import('@/pages/ResourceManage/PermissionManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/menuManage',
    name: '菜单管理',
    components: {
      default: () => import('@/pages/ResourceManage/MenuManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/permissionTemplate',
    name: '权限模板',
    components: {
      default: () => import('@/pages/ResourceManage/PermissionTemplate'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }
]

// 系统管理
export const SystemManage = [
  {
    path: 'subSystemManage',
    name: '子系统管理',
    components: {
      default: () => import('@/pages/SystemManage/SubSystemManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'versionManage',
    name: '系统版本',
    components: {
      default: () => import('@/pages/SystemManage/VersionManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'journalManage',
    name: '系统日志',
    components: {
      default: () => import('@/pages/SystemManage/JournalManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'systemAdministrator',
    name: '系统管理员',
    components: {
      default: () => import('@/pages/SystemManage/SystemAdministrator'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'accountManage',
    name: '系统账号',
    components: {
      default: () => import('@/pages/SystemManage/accountManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'accountDetail',
    name: '账号详情',
    components: {
      default: () => import('@/pages/SystemManage/accountDetail'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'SystemConfig',
    name: '系统配置',
    components: {
      default: () => import('@/pages/SystemManage/SystemConfig/SystemConfig'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'ThemeConfig',
    name: '主题配置',
    components: {
      default: () => import('@/pages/SystemManage/SystemConfig/ThemeConfig'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }
]

// 组织管理
export const OrganizationManage = [
  {
    path: 'unitRelationMaintain',
    name: '单位关系维护',
    components: {
      default: () => import('@/pages/orgainzeManage/UnitRelationMaintain'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'unitManage',
    name: '单位管理',
    components: {
      default: () => import('@/pages/orgainzeManage/UnitManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'unitAudit',
    name: '单位审核',
    components: {
      default: () => import('@/pages/orgainzeManage/UnitAudit'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'addUnit',
    name: '添加单位',
    components: {
      default: () => import('@/pages/orgainzeManage/AddUnit'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'editUnit',
    name: '编辑单位',
    components: {
      default: () => import('@/pages/orgainzeManage/EditUnit'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'OBSMaintain',
    name: 'OBS维护',
    components: {
      default: () => import('@/pages/orgainzeManage/OBSMaintain'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'unitSelect',
    name: '通用单位选择',
    components: {
      default: () => import('@/pages/orgainzeManage/UnitSelect'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'businessSelect',
    name: '选择业务范围',
    components: {
      default: () => import('@/pages/orgainzeManage/BusinessSelect'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'distributionPeople',
    name: '分配人员',
    components: {
      default: () => import('@/pages/orgainzeManage/DistributionPeople'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'organizationManage',
    name: '组织管理',
    components: {
      default: () => import('@/pages/orgainzeManage/OrganizationManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'checkPermiss',
    name: '查看权限列表',
    components: {
      default: () => import('@/pages/orgainzeManage/CheckPermiss'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'moduleDistribution',
    name: '按模板分配',
    components: {
      default: () => import('@/pages/orgainzeManage/ModuleDistribution'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'auditDetails',
    name: '审核详情',
    components: {
      default: () => import('@/pages/orgainzeManage/AuditDetails'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: 'auditModify',
    name: '审核修改',
    components: {
      default: () => import('@/pages/orgainzeManage/AuditModify'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }
]

// 登录，入驻相关页面
export const Login = [
  {
    path: '/login',
    name: '登录',
    components: {
      default: () => import('@/pages/Login/Login')
    }
  },
  {
    path: '/mobileLookProgress',
    name: '移动端查看进度',
    components: {
      default: () => import('@/pages/Login/MobileLookProgress')
    }
  },
  {
    path: '/mobileApplicationChannels',
    name: '申请进度查询',
    components: {
      default: () => import('@/pages/Login/MobileApplicationChannels')
    }
  },
  {
    path: '/otherChannelsApplication',
    name: '单位入驻申请',
    components: {
      default: () => import('@/pages/Login/OtherChannelsApplication')
    }
  },
  {
    path: '/lookProgressOtherChanel',
    name: '其它渠道查看进度',
    components: {
      default: () => import('@/pages/Login/LookProgressOtherChanel')
    }
  },
  {
    path: '/otherChannel',
    name: '单位入驻申请移动端',
    components: {
      default: () => import('@/pages/Login/OtherChannel')
    }
  },
  {
    path: '/otherChannelModify',
    name: '单位入驻申请移动端-修改',
    components: {
      default: () => import('@/pages/Login/OtherChannelModify')
    }
  },
  {
    path: '/lookPro',
    name: '查看进度移动端',
    components: {
      default: () => import('@/pages/Login/LookPro')
    }
  },
  {
    path: '/ruzhuShenqing',
    name: '入驻申请',
    components: {
      default: () => import('@/pages/Login/RuzhuShenqing')
    }
  },
  {
    path: '/chakanjindu',
    name: '查看进度',
    components: {
      default: () => import('@/pages/Login/chakanjindu')
    }
  }
]

// 大屏定制化相关页面
export const ScreenEditor = [
  {
    path: '/screenEditor',
    name: '大屏定制化',
    components: {
      default: () => import('@/pages/ScreenEditor/ScreenEditor')
    }
  },
  {
    path: '/pageComponentManage',
    name: '页面模块维护',
    components: {
      default: () => import('@/pages/ScreenEditor/PageComponentManage'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/pageComponentCustom',
    name: '页面模块定制',
    components: {
      default: () => import('@/pages/ScreenEditor/PageComponentCustom'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  },
  {
    path: '/companyPageCustom',
    name: '单位类型页面模块定制',
    components: {
      default: () => import('@/pages/ScreenEditor/CompanyPageCustom'),
      top: TopNav,
      aside: LeftNav,
      activeTabs: ActiveTabs
    }
  }
]

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/pagePreview',
      name: '页面预览',
      components: {
        default: () => import('@/pages/ScreenEditor/PagePreview')
      }
    },
    ...Login,
    {
      path: '/',
      name: 'home',
      component: index,
      redirect: '/home',
      children: [
        ...ServiceManage,
        ...SettingManage,
        ...ResourceManage,
        ...SystemManage,
        ...OrganizationManage,
        ...ScreenEditor,
        {
          path: '/home',
          name: '首页',
          components: {
            default: home,
            top: TopNav,
            aside: LeftNav,
            activeTabs: ActiveTabs
          }
        },

        {
          path: '/system',
          name: '系统',
          components: {
            default: systeam,
            top: TopNav,
            aside: LeftNav,
            activeTabs: ActiveTabs
          }
        }

        // {
        //   path: '/accessManage',
        //   name: '接入方管理',
        //   components: {
        //     default: AccessManage,
        //     top: TopNav,
        //     aside: LeftNav,
        //     activeTabs: ActiveTabs
        //   },
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        // {
        //   path: '/serveManage',
        //   name: '服务管理',
        //   components: {
        //     default: ServeManage,
        //     top: TopNav,
        //     aside: LeftNav,
        //     activeTabs: ActiveTabs
        //   },
        //   meta: {
        //     requiresAuth: true
        //   }
        // },

      ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js